<template>
    <div class="container" style="margin-top: 90px;">
        <h4 class="d-flex justify-content-center"><b style="color: green;">ASSESSOR</b></h4>
        <div v-if="academicCandidates.length > 0" class="my-3 container mx-3">
            <h4 class="text-start" style="color: grey;"><b>Academic Staff</b></h4>
            <div  class="mt-2 text-start">
                <h5><b>Candidates to Appraise:</b></h5>
                <h6 class="names" v-for="candidate, candidateIndex in academicCandidates">
                    <router-link :to="'/candidate/' + candidate._id + token">
                        ({{ candidateIndex + 1 }}) {{ candidate.name }}
                    </router-link>
                </h6>
            </div>
        </div>
        <div v-if="nonacademicCandidates.length > 0" class="my-3 mt-4 container mx-3">
            <h4 class="text-start" style="color: grey;"><b>Non-academic Staff</b></h4>
            <div class="mt-2 text-start">
                <h5><b>Candidates to Appraise:</b></h5>
                <h6 class="names" v-for="candidate, candidateIndex in nonacademicCandidates">
                    <router-link :to="'/nonacademicAssessorSection2/' + candidate._id">
                        ({{ candidateIndex + 1 }}) {{ candidate.name }}
                    </router-link>
                </h6>
            </div>
        </div>
        <div v-if="(academicCandidates.length <= 0) && (nonacademicCandidates.length <= 0)">
            <b>No candidates to assess</b>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'assessor',
    emits: ['toggleLoader'],
    data() {
        return {
            academicCandidates: [],
            nonacademicCandidates: [],
            token: ''
        }
    },
    created(){
        this.getCandidates()
    },
    methods: {
        async getCandidates() {
            this.$emit('toggleLoader');

            this.token = this.$route.query.token ? '?token=' + this.$route.query.token : '';

            const candidates = await DataService.getCandidates();

            if (candidates) {
                for (var i = 0; i < candidates.length; i++) {
                    if (candidates[i].staffType == "Academic Teaching"){
                        this.academicCandidates.push(candidates[i])
                    } else {
                        this.nonacademicCandidates.push(candidates[i])
                    }
                }
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>